
<div class="CommonContainerCard border__radius8 m-top CommonBorderColor">
<div class="step1_addShip">
    <div class="basicInfo">
        <span class="sub-heading-s1 fleet-section-title basicInfoText">Basic Information</span>
        <!-- <form [formGroup]="basicForm" class="basicForm"> -->
            <snl-action-panel class="ship-action-panel">
                <div left-side class="CommonFiltersPanel df-c action-panel">
                    <div class="serachInput">
                        <app-search-input 
                            [label]="'Ship'"
                            [data]="viewModel.shipsData"
                            [searchText] = "viewModel.searchText"
                            (searchValue) = "valueChange($event)"  
                            [addShipErrormsg]="'addShipPage'"  
                            (emitNoShipFound)="noShipFoundEvent($event)"                
                        ></app-search-input>
                        <div class="updateSearch" *ngIf="updateSearch">
                            {{updateSearch}}
                        </div>
                    </div>
                    
                    <div class="dropdown-col _TextFltr textSubpool" [ngClass]="shipErrorMessage ? 'errFoundShip' : ''" *ngIf="subPoolslist?.length">
                        <snl-dropdown class="addShip-input-text" [label]="'Pool'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                        [options]="subPoolslist" 
                        [showAll]="true"
                        [isInsideModal]="false"
                        (selectedValues)="selectedValues($event,'shipPool')"
                        [preSelectedItems]="selectedSubpool"
                        (resetDropdown)="resetDropdown($event,'shipPool')"
                        ></snl-dropdown>
                        <!-- <div class="updateSubpool" *ngIf="updateSubpool">
                            {{updateSubpool}}
                        </div> -->
                    </div>
                    <div class="dropdown-col _TextFltr _TextShipOwner" *ngIf="shipOwnerlist?.length">
                        <snl-dropdown class="addShip-input-text" [label]="'Ship owner'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                        [options]="shipOwnerlist" 
                        [showAll]="true"
                        [isInsideModal]="false"
                        (selectedValues)="selectedValues($event,'shipOwner')"
                        [preSelectedItems]="selectedShipOwner"
                        (resetDropdown)="resetDropdown($event,'shipOwner')"
                        ></snl-dropdown>
                        <!-- <div class="updateShipowner" *ngIf="updateShipowner">
                            {{updateShipowner}}
                        </div> -->
                    </div>
                </div>
            </snl-action-panel>   
            <div class="ClassText" >
                <div class="body-b fleet-body-b3">Class</div>
                <div class="section-title fleet-section-title" *ngIf="scrubberVal?.length">{{scrubberVal[0].vslClass ? scrubberVal[0].vslClass : '-' }}</div>
                <div class="section-title fleet-section-title new" *ngIf="!scrubberVal?.length && !updateClass">-</div>
                <div class="section-title fleet-section-title updateClass" *ngIf="updateClass">
                    {{updateClass ? updateClass : '-'}}
                </div>
               
            </div>
            <div class="datePicker addShip-input-text">
                <snl-date-picker-dropdown class="addShipsDatePicker"
                datePickerType="date"
                title="Effective date of activation"
                (selectedDate)=selectedDate($event)
                ></snl-date-picker-dropdown>
                 <div class="updateDate section-title" *ngIf="updateDate">
                    {{updateDate | date:'dd MMM yyyy'}}
                </div>
                <div class="text body-b fleet-body-b3" *ngIf="showDatetext">Effective date of activation is in a future date, the initial status of this ship will be “Pending”</div>
                <div class="text body-b fleet-body-b3" *ngIf="getAddShipdateselected && !showDatetext">
                    Effective date of activation is in a past/current date, the initial status of this ship will be "Active”
                </div>
            </div>
            <div class="line"></div>
            <div class="toggleValue">
                <div class="scrubberSection">
                    <span class="scrubberText text  body-b1 fleet-section-title">Is Scrubber in use?</span>
                    <snl-switch
                    [toggleState]="switchScrubber"
                    (toggle)="toggleScrubber($event)"
                    [activeText]="'Yes'"
                    [inActiveText]="'No'"
                    ></snl-switch>
                </div>
                <div class="lngSection">
                    <span class="scrubberText text body-b1 fleet-section-title">Is LNG in use?</span>
                    <snl-switch
                    [toggleState]="switchLng"
                    (toggle)="toggleLng($event)"
                    [activeText]="'Yes'"
                    [inActiveText]="'No'"
                    ></snl-switch>
                </div>
            </div>
        <!-- </form> -->
        
    </div>
</div>
</div>